"use client";

import Image from "next/image";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useState, useEffect } from "react";
import { cn } from "../lib/utils";
import dynamic from "next/dynamic";
import data from "../data/home";

const CalendlyButton = dynamic(() => import("./calendly"), {
  ssr: false,
});

const ACCESS_KEY = "cf9c84e5-95f4-46ee-a26a-bf7512e27c56";

const ContactUs = () => {
  const [isSending, setIsSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const isAIPage = pathname === "/ai";
  const models = data.models;
  const selectedModel = searchParams.get("model");
  const budgets = [
    "$0 - $5k",
    "$5 - $10k",
    "$10 - $20k",
    "$20 - $50k",
    "More than $50k",
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    // console.log(e.target)
    const formData = new FormData(e.target);
// console.log(formData)
    formData.append("access_key", ACCESS_KEY);

    try {
      // Web3Forms email notifications
      if (!(process.env.NODE_ENV === "development")) {
        await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          body: formData,
        }).then((res) => res.json());
      }

      // db update
      // const res = await fetch("/api/contact", {
      //   method: "POST",
      //   body: formData,
      // }).then((res) => res.json());

      // if (res.success) {
      if (true) {
        setSuccess(true);
        setIsSending(false);
        setTimeout(() => {
          router.push("/");
        }, 2000);
      } else {
        console.log(res);
        setError(res.message);
      }
    } catch (error) {
      setIsSending(false);
      setError("Error occured while sending message. Try again.");
    }
  };

  useEffect(() => {
    if (success) {
      const params = new URLSearchParams();
      params.set("success", true);
      window.location.search = params;
    }
  }, [success]);

  return (
    <div className="p-6 bg-palette-neutral-1 shadow-2xl rounded-2xl">
      <div className="flex flex-col justify-center items-center">
        <Image
          src="/assets/profiles/vaibhav.jpeg"
          width={500}
          height={500}
          alt="Vaibhav Nandwani"
          className="rounded-full w-32 lg:w-36 aspect-square object-cover -translate-y-1/2"
        />
        <div className="-mt-12 text-center">
          <p className="font-bold">Vaibhav Nandwani</p>
          <p>Co-Founder</p>
          <p className="opacity-80">vaibhav@asynq.ai</p>
          {/* <Link
              href="tel:+48600023843"
              className="opacity-80 hover:underline">
              +48 600 023 843
            </Link> */}
        </div>
      </div>
      <form
        onSubmit={handleSubmit}
        className={cn(
          "relative w-full max-w-2xl flex",
          "flex-col items-start justify-start",
        )}>
        <div className="flex flex-col w-full">
          <label
            htmlFor="name"
            className="text-palette-neutral-4 font-semibold">
            Your Name <span className="text-red-500">*</span>
          </label>
          <input
            type="name"
            name="name"
            required
            id="name"
            className="border w-full hover:border-palette-primary-2 active:border-palette-primary-2 border-palette-neutral-4 rounded-md p-2 mt-2"
          />
        </div>
        <div className="flex flex-col w-full mt-6">
          <label
            htmlFor="email"
            className="text-palette-neutral-4 font-semibold">
            Your Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="email"
            required
            id="email"
            className="border w-full hover:border-palette-primary-2 active:border-palette-primary-2 border-palette-neutral-4 rounded-md p-2 mt-2"
          />
        </div>
        <div className="flex flex-col w-full mt-6">
          <label
            htmlFor="contact_number"
            className="text-palette-neutral-4 font-semibold">
            Contact Number
          </label>
          <input
            type="tel"
            name="contact_number"
            id="contact_number"
            maxLength={50}
            className="border w-full hover:border-palette-primary-2 active:border-palette-primary-2 border-palette-neutral-4 rounded-md p-2 mt-2"
          />
        </div>
        {!isAIPage && (
          <>
            <div className="flex flex-wrap w-full justify-between gap-2 mt-6">
              <div className="flex flex-col gap-2">
                <label
                  htmlFor="intention"
                  className="text-palette-neutral-4 font-semibold">
                  I want to:
                </label>
                <select
                  defaultValue={selectedModel}
                  name="intention"
                  id="intention"
                  className="p-2 bg-neutral-500 text-palette-neutral-1 rounded-md active:rounded-b-none">
                  {models.map((model) => (
                    <option key={model.name} value={model.name}>
                      {model.name}
                    </option>
                  ))}
                  <option value="Say Something Else">Say Something Else</option>
                </select>
              </div>
              <div className="flex flex-col gap-2">
                <label
                  htmlFor="budget"
                  className="text-palette-neutral-4 font-semibold">
                  Estimated Budget
                </label>
                <select
                  name="budget"
                  id="budget"
                  className="p-2 bg-neutral-500 text-palette-neutral-1 rounded-md active:rounded-b-none">
                  {budgets.map((budget) => (
                    <option key={budget} value={budget}>
                      {budget}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex flex-col w-full mt-6">
              <label
                htmlFor="message"
                className="text-palette-neutral-4 font-semibold">
                Message
              </label>
              <textarea
                type="text"
                name="message"
                id="message"
                className="border w-full min-w-full hover:border-palette-primary-2 active:border-palette-primary-2 border-palette-neutral-4 rounded-md p-2 mt-2"
              />
            </div>
          </>
        )}
        {!isAIPage && (
          <>
            <p className="text-palette-neutral-4 text-sm mt-6">
              I consent to receive marketing and other forms of communication
              from ASYNQ
            </p>
            <div className="flex gap-2 mt-2">
              <input
                type="radio"
                name="consent"
                id="consent"
                className="w-6 h-6 mt-0 accent-palette-primary-2"
              />
              <label htmlFor="consent">Yes</label>
            </div>
          </>
        )}
        {success && (
          <p className="mt-4 p-2 w-full border border-green-900 bg-green-100 text-green-950 rounded-md">
            Successfully sent message. Redirecting to homepage...
          </p>
        )}
        {error && (
          <p className="mt-4 p-2 w-full border border-red-900 bg-red-100 text-red-950 rounded-md">
            Error occured while sending message.
          </p>
        )}
        <div className="hover:bg-palette-primary-2 text-palette-neutral-2 bg-palette-neutral-4 rounded-md p-3 w-full my-4 transition-colors duration-300">
          {isSending ? (
            <svg
              className="w-full fill-white rounded-md"
              width="24"
              height="24"
              viewBox="0 0 24 24">
              <circle cx="4" cy="12" r="3">
                <animate
                  id="spinner_qFRN"
                  begin="0;spinner_OcgL.end+0.25s"
                  attributeName="cy"
                  calcMode="spline"
                  dur="0.6s"
                  values="12;6;12"
                  keySplines=".33,.66,.66,1;.33,0,.66,.33"
                />
              </circle>
              <circle cx="12" cy="12" r="3">
                <animate
                  begin="spinner_qFRN.begin+0.1s"
                  attributeName="cy"
                  calcMode="spline"
                  dur="0.6s"
                  values="12;6;12"
                  keySplines=".33,.66,.66,1;.33,0,.66,.33"
                />
              </circle>
              <circle cx="20" cy="12" r="3">
                <animate
                  id="spinner_OcgL"
                  begin="spinner_qFRN.begin+0.2s"
                  attributeName="cy"
                  calcMode="spline"
                  dur="0.6s"
                  values="12;6;12"
                  keySplines=".33,.66,.66,1;.33,0,.66,.33"
                />
              </circle>
            </svg>
          ) : (
            <button className="w-full">Submit</button>
          )}
        </div>
        {!isAIPage && (
          <>
            <div className="text-center py-4 w-full font-medium relative isolate">
              <span className="p-2 bg-palette-neutral-1">OR</span>
              <div
                className={cn(
                  "border-b border-b-palette-neutral-4 absolute",
                  "top-1/2 -translate-y-1/2 left-0 w-full -z-10",
                )}></div>
            </div>
            <CalendlyButton className={"w-full mt-2 py-3"} />
            <p className="text-palette-neutral-3 text-sm mt-4">
              Fields marked as <span className="text-red-500">*</span> are
              required.
            </p>
          </>
        )}
        <p className="text-palette-neutral-3 text-sm mt-4">
          Never share sensitive information (credit card numbers, social
          security numbers, passwords) through this form.
        </p>
      </form>
    </div>
  );
};

export default ContactUs;
